export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.startsWith("/install")) {
    let referrerId = to.query["referrerId"] as string
    if (!referrerId && decodeURIComponent(to.path).startsWith("/install?")) {
      // 인코딩 되어있을때
      return navigateTo(decodeURIComponent(to.path))
    }
    const referrerOnelink = useRuntimeConfig().public.REFERRER_ONELINK
    const link = referrerId
      ? `${referrerOnelink}?af_force_deeplink=true&deep_link_sub1=${referrerId}`
      : `${referrerOnelink}?af_force_deeplink=true`

    navigateTo(link, { external: true })
  }
});
